import React from "react";
import { Box, Typography, Grid, Card, CardContent } from "@mui/material";
import "./Newhome.css";
import { useLanguage } from "../../../utils/languageContext";

const Aboutacross = () => {
  const { t } = useLanguage();

  const programs = [
    {
      key: "ncd",
      icon: "/images/NCDacross.svg",
      class: "border-orange",
    },
    {
      key: "janani",
      icon: "/images/Jannniacross.svg",
      class: "border-purple",
    },
    {
      key: "uwin",
      icon: "/images/Uwinacross.svg",
      class: "border-pink",
    },
    {
      key: "nikshay",
      icon: "/images/Nikshayacross.svg",
      class: "border-yellow",
    },
    {
      key: "pmndp",
      icon: "/images/PMNDPacross.svg",
      class: "border-blue",
    },
    {
      key: "sath",
      icon: "/images/Sathacross.svg",
      class: "border-orange2",
    },
  ];

  return (
    <>
      {/* 🔶 SECTION 1: ABOUT SWASTH BHARAT */}
      <Box className="about-section" id="about-section">
        <Typography className="program-title about-title">
          {t("homepage.about.title")}{" "}
          <span className="bgcolorspan">
            {t("homepage.about.titleHighlight")}
          </span>
        </Typography>

        <Grid container spacing={4} alignItems="center">
          <Grid size={{ xs: 12, md: 6 }}>
            <img
              src="/images/Aboutsvgcontact.png"
              alt="About"
              className="about-img"
            />
          </Grid>

          <Grid item size={{ xs: 12, md: 6 }}>
            <Typography className="about-text">
              {t("homepage.about.description")}
            </Typography>
          </Grid>
        </Grid>
      </Box>

      {/* 🔷 SECTION 2: PROGRAMS */}
      <Box className="programhome-section">
        <Typography className="programhome-title">
          {t("homepage.programs.title")}{" "}
          <span className="bgcolorspan">
            {t("homepage.programs.titleHighlight")}
          </span>
        </Typography>
        <Grid container spacing={3}>
          {programs.map((item) => (
            <Grid size={{ xs: 12, sm: 6, md: 4, lg: 2 }} key={item.key}>
              <Card className={`programhome-card ${item.class}`}>
                <CardContent className="programhome-content">
                  {/* 🔥 ICON */}
                  <div className="programhome-icon-box">
                    <img src={item.icon} alt="icon" />
                  </div>

                  <Typography className="programhome-name">
                    {t(`homepage.programs.${item.key}.title`)}
                  </Typography>

                  <Typography className="programhome-desc">
                    {t(`homepage.programs.${item.key}.desc`)}
                  </Typography>

                  <Typography className="programhome-value">
                    {t(`homepage.programs.${item.key}.value`)}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </>
  );
};

export default Aboutacross;
